import { render } from "./FillBlankTableExerciseComponent.vue?vue&type=template&id=2f2c5fd5&scoped=true"
import script from "./FillBlankTableExerciseComponent.vue?vue&type=script&lang=js"
export * from "./FillBlankTableExerciseComponent.vue?vue&type=script&lang=js"

import "./FillBlankTableExerciseComponent.vue?vue&type=style&index=0&id=2f2c5fd5&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2c5fd5"]])

export default __exports__